// const $window = $(window);
// let windowWidth = $window.width();

// // メディアクエリ
// let mql = window.matchMedia('screen and (max-width: 1024px)');

//preload
import {preload} from "../include/module";
preload();

// toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//pageTop
import {pageTop} from "../include/module";
pageTop();

// //showMovie
// import {showMovie} from "../include/module";
// showMovie();

// //showImg
// import {showImg} from "../include/module";
// showImg();

//showAbout
import {showAbout} from "../include/module";
showAbout();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();


$(window).on('load' , function() {

  setTimeout(function(){$('.js-loadingAnimation').addClass("is-animated");},200);
  scrollIndexAnime();
  toggleBox();
  tabSwitching();

});


// ------------------------------------------------------------------------
// scrollIndexAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollIndexAnime = () => {

  const controller = new ScrollMagic.Controller();



  //ページトップ出現
  const scene = new ScrollMagic.Scene({
    triggerElement:'.index-Story',
    triggerHook: 1,
    offset: '100'
  })
  .setClassToggle('#st-Top', 'st-Top-Show')
  .addTo(controller);

  //メニュー出現
  new ScrollMagic.Scene({
    triggerElement:'.index-Story',
    triggerHook: 0,
    offset: '100'
  })
  .setClassToggle('#st-Menu', 'st-Menu-Show')
  // .addIndicators({name: "1"})
  .addTo(controller);

  // //アプリ誘導
  // new ScrollMagic.Scene({
  //   triggerElement:'.index-Story',
  //   triggerHook: 1,
  //   offset: '80'
  // })
  // .setClassToggle('#following', 'show')
  // .addTo(controller);

  // //アプリ誘導
  // new ScrollMagic.Scene({
  //   triggerElement:'.st-Footer',
  //   triggerHook: 1,
  //   offset: '80'
  // })
  // .setClassToggle('#following, #st-Top', 'hidden')
  // .addTo(controller);

  //　スクロールで発火系
  const targets = document.querySelectorAll(".js-scrollAnimation");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
    new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: .95
    })
    .setClassToggle(target, "is-animated")
    .addTo(controller);
  });


  // 背景
  new ScrollMagic.Scene({
    triggerElement:'#song',
    duration: 1500,
    // triggerHook: .5,
    // offset: '0'
  })
  // .setPin("#index-Song_Bg")
  .on("progress", function (prog) { // 使いたいシーンに対してprogressイベントを設定します
    var p = prog.progress; // 0～1の値が入ってきます
    anime({
      targets:"#index-Song_Bg",
      translateY: -p * 220,
      elasticity: 0,
      easing: 'linear'
    });
  })
  // .setClassToggle(".scene-Rain_Notice_Txt, .scene-Rain_Notice_Date", "show")
  // .addIndicators({name: "1"})
  .addTo(controller);

};

// ------------------------------------------------------------------------
// toggleBox
// ----- BOTH
// ------------------------------------------------------------------------
const toggleBox = () => {
  $(".toggle_Button").on("click", function() {
    $(this).next().slideToggle(300);
    $(this).toggleClass("open");
  });
};


// ------------------------------------------------------------------------
// tabSwitching
// ----- BOTH
// ------------------------------------------------------------------------
const tabSwitching = () => {

  $(document).on('click','.movie_Tab_Item', function(){
    var targetid = $(this).data('movie');
    var idx=$('.movie_Tab_Item').index(this);
    $(this).addClass('current').siblings('.movie_Tab_Item').removeClass('current');
    $(this).closest('.movie_Tab').next('.movie_Contents').find('.movie_Contents_Item').removeClass('is-show is-animation');
    $('.movie_Contents_Item').eq(idx).addClass('is-show');
  });


};


// WEBPACK FOOTER //
// ./src/assets/js/index/script.js